import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { DconConfigAPI } from '../../features/dfte-grid-view/config/config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CloudExtractLoadService {
  options: any;
  instanceName: string;
  configType: string = 'load';
  tabval = new BehaviorSubject('select');
  batchKey: string;
  authorizationData: any;
  projId: string;
  instanceList: string;
  authToken: string;
  configObj: any;
  token: any;
  tracksFromTable: any;
  batchKeyDetails: any;
  fromTable: boolean = false;
  submitResponse: any;
  configFileList: any;
  extractBatchKey: string;
  fileUploadedTaskList: any[] = [];
  // tabval= this.tabEnable.asObservable();
  requestedBy: string;
  Base_Url: string;
  Base_UI_BOT = DconConfigAPI.UI_PATH;
  nodeBaseUrl = DconConfigAPI.NODE_URL;

  constructor(
    // private  configFile : DconConfigAPI,
    private dataSrv: DataService,
    private https: HttpClient) {
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    console.log("val", this.projId);
    // this.dataSrv.projectId.subscribe(val => {
    //   this.projId = val;
    // });
    this.dataSrv.token.subscribe(val => {
      this.token = val;
      this.authToken = 'Bearer ' + this.token;
    });
    this.requestedBy = this.dataSrv.loggedUserId;
  }

  getisTrainStopUrl() {
    const isTrainStopUrl = this.dataSrv.getisTrainStopUrl();
    return isTrainStopUrl;
  }

  getfileSharePath() {
    return this.dataSrv.windowFileSharePath;
  }

  getConfigTemplatePath() {
    return this.dataSrv.configTemplatePath;
  }



  getLoadBatchkeys(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_BATCHKEY_UI + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Project_Name": this.projId,
      "Requested_By": this.dataSrv.loggedUserId,
      "Request_Type": DconConfigAPI.API_VARIABLES.Request_Type_Load,
      "Source": DconConfigAPI.API_VARIABLES.CLOUD
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getInstanceDetails(type: string): Observable<any> {
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_INSTANCE_DETAILS + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Source_Type": type,
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getConfigDetails(type: string): Observable<any> {
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_CONFIG_DETAILS + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Request_Type": type,
      'Extract_Application': DconConfigAPI.API_VARIABLES.CLOUD //'CLOUD'
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  onConfigSubmit(body): Observable<any> {
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.INSERT_BATCHKEY_DETAILS + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.post(url, body, options);
  }

  getBatchKeyDetails(batchKey): Observable<any> {
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_BATCHKEY_DETAILS_UI + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Project_Name": this.projId,
      "Requested_By": this.dataSrv.loggedUserId,
      "Request_Type": DconConfigAPI.API_VARIABLES.Request_Type_Load,
      'Extract_Application': DconConfigAPI.API_VARIABLES.CLOUD,//'CLOUD',
      "Batch_Key": batchKey
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getExtractDetails(): Observable<any> {
    // const url = this.Base_UI_BOT + DconConfigAPI.URL_PROPS.ODATA_RELEASES_FILTER + DconConfigAPI.UIPATH_PROCESS_NAME + "'";
    // const headers = new HttpHeaders({
    //   'Authorization': this.authToken,
    //   // "Request_Type"  : type,
    //   // 'Extract_Application'  :  'CLOUD'
    // });
    // const options = { headers: headers };
    // return this.https.get(url, options);
    const payload = {
      token:this.authToken,
      assetName: DconConfigAPI.UIPATH_PROCESS_NAME
    };
    return this.https.post(DconConfigAPI.NODE_URL + "/uipath/uipath-releases",payload)
  }

  // createFolder(payloadObj): Observable<any> {
  //   const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.CLOUDLOAD_CREATEFOLDER;
  //   const headers = new HttpHeaders({
  //     'Authorization': this.authToken,
  //   });
  //   const options = { headers: headers };
  //   return this.https.post(url, payloadObj, options);
  // }
  createFolder(payloadObj): Observable<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.CLOUDLOAD_CREATEFOLDER;
  
    if (environment.isBasicAuth) {
   
      const token = localStorage.getItem('authToken'); 
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
  
      payloadObj.isBasicAuth = true;
  
      return this.https.post(url, payloadObj, { headers });
    } else {

      return this.https.post(url, payloadObj);
    }
  }
  
 
  onExtract(body): Observable<any> {
    // const url = this.Base_UI_BOT + DconConfigAPI.URL_PROPS.ODATA_JOBS_STARTJOBS;
    // const headers = new HttpHeaders({
    //   'Authorization': this.authToken,
    // });
    // const options = { headers: headers };
    // return this.https.post(url, body, options);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers: headers };

    const payload = {
      startInfo: body.startInfo,
      token: this.authToken,
      orgId: DconConfigAPI.OrganizationUnitId
    };
    return this.https.post(DconConfigAPI.NODE_URL + "/uipath/uipath-server-config-start-jobs", payload, options);  
  }

  onLoadUpdate(body): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.UPDATE_BATCHKEY_DETAILS + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
    });
    const options = { headers: headers };
    return this.https.put(url, body, options);
  }

  downloadFiles(payloadObj): Observable<any> {
    const url = DconConfigAPI.NODE_URL + DconConfigAPI.URL_PROPS.BOT_DOWNLOAD_FILE;
    return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
  }

  // downloadFilesFromTable(payloadObj): Observable<any> {
  //   const url = DconConfigAPI.NODE_URL + DconConfigAPI.URL_PROPS.CLOUD_LOAD_DOWNLOAD;
  //   return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
  // }
  downloadFilesFromTable(payloadObj): Observable<any> {
    const url = DconConfigAPI.NODE_URL + DconConfigAPI.URL_PROPS.CLOUD_LOAD_DOWNLOAD;
  
    if (environment.isBasicAuth) {
      const token = localStorage.getItem('authToken'); 
  
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
  
      payloadObj.isBasicAuth = true;
  
      return this.https.post(url, payloadObj, { headers, responseType: 'arraybuffer' });
    } else {
      return this.https.post(url, payloadObj, { responseType: 'arraybuffer' });
    }
  }
  

  getExtractBatchKeyDetails(batchKey): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_BATCHKEY_DETAILS_UI + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Project_Name": this.projId,
      "Requested_By": this.dataSrv.loggedUserId,
      "Request_Type": DconConfigAPI.API_VARIABLES.Request_Type_Extract,
      'Extract_Application': DconConfigAPI.API_VARIABLES.CLOUD,//'CLOUD',
      "Batch_Key": batchKey
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  getSelectedBatchTasks(): Observable<any> {
    this.Base_Url = this.dataSrv.UI_ORDS + DconConfigAPI.UI_BATCH_KEY;
    this.authorizationData = this.dataSrv.ordstAuthData;
    this.projId = this.dataSrv.projectID;
    const url = this.Base_Url + DconConfigAPI.URL_PROPS.GET_CLOUDLOAD_DATA + DconConfigAPI.UI_GRANT_TYPE;
    const headers = new HttpHeaders({
      'Authorization': this.authorizationData,
      "Project_Name": this.projId,
      "Requested_By": this.dataSrv.loggedUserId,
      "Source_Type": DconConfigAPI.API_VARIABLES.CLOUD
    });
    const options = { headers: headers };
    return this.https.get(url, options);
  }

  // async uploadExtractFromCloudLoad(formData) {
  //   const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.UPLOAD_CLOUD_LOAD;
  //   const req = new HttpRequest('POST', url, formData, {
  //     headers: new HttpHeaders({
  //       'Access-Control-Allow-Origin': '*',
  //       'ignoreInInterceptor': 'true'
  //     })
  //   });
  //   return await this.https.request(req);
  // }
  async uploadExtractFromCloudLoad(formData): Promise<any> {
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.UPLOAD_CLOUD_LOAD;
  
   
    let headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'ignoreInInterceptor': 'true'
    });
  
    // Add Basic Auth headers and modify payload if Basic Auth is enabled
    if (environment.isBasicAuth) {
      const token = localStorage.getItem('authToken'); 
      headers = headers.append('Authorization', `Bearer ${token}`);
  
      
      formData.append('isBasicAuth', 'true');  
    } 
  
   
    const req = new HttpRequest('POST', url, formData, { headers });
  
 
    return await this.https.request(req).toPromise();
  }
  
}
